import axios from 'axios'
import store from '../index'
import { make } from 'vuex-pathify'
import { showError } from '@/util/helpers'

const state = {
  subscription: {},
  loading: false,
}

const mutations = make.mutations(state)

const normalizeSubscription = (subscription = {}) => ({
  ...subscription,
  paymentStatus: subscription.paymentStatus || null,
  subscribed: !!subscription.subscribed,
  billingSyncStatus: subscription.billingSyncStatus || null,
  billingSyncReason: subscription.billingSyncReason || null,
  billingSyncRetryable: subscription.billingSyncRetryable ?? null,
  billingSyncUpdatedAt: subscription.billingSyncUpdatedAt || null,
  ignoreBilling: subscription.ignoreBilling ?? subscription.ignoreStripe ?? false,
  openBillingNotice: subscription.openBillingNotice || null,
})

const syncCompanySubscription = (subscription) => {
  const currentCompany = store.get('authStore@currentCompany')
  if (!currentCompany) {
    return
  }

  store.commit('authStore/setCompany', {
    ...currentCompany,
    ...subscription,
  })
}

const actions = {
  async getSubscription ({ state }, companyId) {
    state.loading = true

    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/subscription`, {
        params: {
          companyId: companyId || store.get('authStore@currentCompany')?.id,
        },
      })

      const subscription = normalizeSubscription(data)
      state.subscription = subscription
      syncCompanySubscription(subscription)
      return subscription
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.loading = false
    }
  },

  async refreshStatus ({ dispatch }) {
    const companyId = store.get('authStore@currentCompany')?.id
    if (!companyId) {
      return null
    }

    return dispatch('getSubscription', companyId)
  },

  async openBillingPdf (_, notice) {
    if (!notice?.boletoPdfPath) {
      throw new Error('PDF do boleto não disponível')
    }

    const signedUrl = await store.dispatch('fileStore/get', {
      path: notice.boletoPdfPath,
    })

    window.open(signedUrl, '_blank')
    return signedUrl
  },
}

const getters = {
  ...make.getters(state),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
